/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Share_Card_HoldInputs */

const en_us2_workout_share_card_hold = /** @type {(inputs: Workout_Share_Card_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hold`)
};

const pt_br2_workout_share_card_hold = /** @type {(inputs: Workout_Share_Card_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isometria`)
};

const es_419_workout_share_card_hold = /** @type {(inputs: Workout_Share_Card_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isometría`)
};

const pt_pt2_workout_share_card_hold = /** @type {(inputs: Workout_Share_Card_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isometria`)
};

const fr_fr2_workout_share_card_hold = /** @type {(inputs: Workout_Share_Card_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gainage`)
};

const de_de2_workout_share_card_hold = /** @type {(inputs: Workout_Share_Card_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halten`)
};

const it_it2_workout_share_card_hold = /** @type {(inputs: Workout_Share_Card_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isometria`)
};

/**
* | output |
* | --- |
* | "Hold" |
*
* @param {Workout_Share_Card_HoldInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_share_card_hold = /** @type {((inputs?: Workout_Share_Card_HoldInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Share_Card_HoldInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_share_card_hold(inputs)
	if (locale === "es-419") return es_419_workout_share_card_hold(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_share_card_hold(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_share_card_hold(inputs)
	if (locale === "de-DE") return de_de2_workout_share_card_hold(inputs)
	if (locale === "it-IT") return it_it2_workout_share_card_hold(inputs)
	return en_us2_workout_share_card_hold(inputs)
});
export { workout_share_card_hold as "workout-share.card_hold" }